import { Box, Container, Grid } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import React, { useEffect } from "react";
import SideBar from "../../components/yourAssets/SideBar";
import { Outlet, useNavigate } from "react-router-dom";
import { getAutditTrail } from "../../services/auditTrails";
import { useDispatch } from "react-redux";
import { getUpdatedData } from "../../redux/slices/AuditTrailSlice";
import { getAssetsOnBoardingList } from "../../redux/slices/features/assetsOnBoardingSlice";

const YourAssets = () => {
  let currentConsultantId = localStorage.getItem("currentConsultantId");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fetchAuditTrail = async () => {
    const result = await getAutditTrail(currentConsultantId);
    if (result?.success) {
      dispatch(getUpdatedData(result?.payLoad));
    } else {
      dispatch(getUpdatedData([]));
    }
  };

  useEffect(() => {
    fetchAuditTrail();
    dispatch(getAssetsOnBoardingList());
  }, [window.location.pathname]);

  const theme = createTheme({
    components: {
      MuiContainer: {
        styleOverrides: {
          root: {
            maxWidth: "1320px",
          },
          maxWidthLg: {
            maxWidth: "1320px!important",
          },
          contained: {
            fontSize: "bold",
          },
        },
      },
    },
    palette: {
      color: {
        magentaDark1: "#444561",
        magentaDark2: "#262B3E",
        magentaDark3: "#917D9E",
        magentaMid1: "#6b607e",
        magentaMid2: "#957ba0",
        $magentaMid3: "#917d9e",
        magentaLight1: "#c298bb",
        magentaLight2: "#dfc8db",
        brown: "#444561",
        dimGrey: "#707070",
        dimGrey2: "#cccccc",
        lightGrey: "#DEDEDE",
        darkGrey: "#a5a5a5",
        black: "#000",
        white: "#fff",
        smokeWhite: "#ededed",
        transparent: "transparent",
        dark1: "#444660",
      },
    },
    typography: {
      allVariants: {
        color: "#444561",
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Box className="family-tree-main-container">
        <Container className="Ft-main">
          <Grid container spacing={5} className="balance-of-assets">
            {/* <Grid item xl={1} lg={1} sm={12} xs={12} /> */}
            <Grid item xl={2} lg={2} sm={12} xs={12} className="side-bar" >
              <SideBar />
            </Grid>
            <Grid item xl={10} lg={10} sm={12} xs={12}>
              <Outlet />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default YourAssets;
